import { render, staticRenderFns } from "./SwitchLayout.vue?vue&type=template&id=23dcb110&"
import script from "./SwitchLayout.vue?vue&type=script&lang=js&"
export * from "./SwitchLayout.vue?vue&type=script&lang=js&"
import style0 from "./SwitchLayout.vue?vue&type=style&index=0&lang=scss&soped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23dcb110')) {
      api.createRecord('23dcb110', component.options)
    } else {
      api.reload('23dcb110', component.options)
    }
    module.hot.accept("./SwitchLayout.vue?vue&type=template&id=23dcb110&", function () {
      api.rerender('23dcb110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/search/SwitchLayout.vue"
export default component.exports